import { Button } from 'antd'
import {
  Container,
  LoginBox,
  LoginDetails,
  Logo,
  InputWrapper,
  Label,
  ErrorWrapper,
  ButtonWrapper,
  PageContainer,
  StyledInput,
} from './index.styled'

import { useAccessCode } from './useAccessCode'
import LogoBadgeOutlined from '../../../images/LogoBadgeOutlined.png'
import LogoutIcon from '../../../images/logout.svg'
import { persistor } from '../../../redux/store'

export default function AccessCodeScreen() {
  const { code, codeError, verifying, setCode, verifyCode } = useAccessCode()

  return (
    <PageContainer>
      {/* Top-left logo */}
      <Logo
        src={LogoBadgeOutlined}
        alt="Kiro logo"
        onClick={() => {
          persistor.purge()
          localStorage.clear()
          window.location.reload()
        }}
      />

      <Container>
        <div
          onClick={() => {
            persistor.purge()
            localStorage.clear()
            window.location.reload()
          }}
          style={{
            background: 'transparent',
            position: 'fixed',
            top: 24,
            right: 32,
            color: '#007F7C',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <img src={LogoutIcon} style={{ marginRight: '8px' }} />
        </div>

        <LoginBox>
          <LoginDetails
            onKeyDown={(e) => {
              if (e.key === 'Enter') verifyCode()
            }}
          >
            <InputWrapper style={{ marginTop: '28px' }}>
              <Label>Access Code</Label>

              <StyledInput
                value={code}
                onChange={(e) => setCode(e.target.value)}
                autoFocus={true}
                inputMode="numeric"
                placeholder="Enter Code"
              />

              {/* Access code error */}
              {codeError && <ErrorWrapper>{codeError}</ErrorWrapper>}

              <ButtonWrapper>
                <Button type="primary" style={{ width: '100%' }} loading={verifying} onClick={verifyCode}>
                  Verify
                </Button>
              </ButtonWrapper>
            </InputWrapper>
          </LoginDetails>
        </LoginBox>
      </Container>
    </PageContainer>
  )
}
